import {ExemplarlisteWrapper} from "@k/global/ExemplarlisteWrapper";

export let exemplarlisteOpener: ExemplarlisteWrapper;

export function setExemplarlisteOpener(exemplarlisteOpenerToSet: ExemplarlisteWrapper) {
    exemplarlisteOpener = exemplarlisteOpenerToSet;
}